import React from "react";
import styles from "./Features.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const FEATURES = [
	{
		title: "Universal TV Remote Control",
		description:
			"Control essential TV functions such as power, volume, channels, navigation, input sources, and playback directly from your phone.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<rect x="6" y="2" width="12" height="20" rx="2" />
				<circle cx="12" cy="17" r="1.5" />
				<path d="M10 7h4M10 10h4" />
			</svg>
		),
	},
	{
		title: "Quick Wi-Fi Connection",
		description:
			"Discover and connect to compatible Smart TVs on the same Wi-Fi network in just a few steps.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<path d="M5 12.55a11 11 0 0 1 14.08 0" />
				<path d="M1.42 9a16 16 0 0 1 21.16 0" />
				<path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
				<circle cx="12" cy="20" r="1" fill="currentColor" stroke="none" />
			</svg>
		),
	},
	{
		title: "Keyboard & Voice Search",
		description:
			"Use your phone’s keyboard to enter text faster or search by voice on supported TV devices.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<rect x="2" y="6" width="20" height="12" rx="2" />
				<path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8" />
			</svg>
		),
	},
	{
		title: "Screen Mirroring & TV Cast",
		description:
			"Mirror your phone screen or cast photos and supported media files to a compatible TV.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<rect x="2" y="4" width="20" height="12" rx="2" />
				<path d="M8 20h8M12 16v4" />
				<path d="M6 12a6 6 0 0 1 12 0" />
			</svg>
		),
	},
	{
		title: "Google Drive Integration",
		description: (
			<>
				Google Sign-In is optional.
				<br />
				TV Remote: Universal Remote requests access to Google Drive
				only after the user chooses to import a file from their own
				Google Drive account.
				<br />
				The application only reads files selected by the user for
				casting. No files are uploaded, modified, deleted, or shared.
			</>
		),
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
			</svg>
		),
	},
];

function Features() {
	return (
		<section className={cx("features")} id="features">
			<div className={cx("grid")}>
				{FEATURES.map((feature) => (
					<article className={cx("card")} key={feature.title}>
						<div className={cx("icon")} aria-hidden="true">
							{feature.icon}
						</div>
						<h3>{feature.title}</h3>
						<p>{feature.description}</p>
					</article>
				))}
			</div>
		</section>
	);
}

export default Features;
